export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/2233c62521ed-tooliconkettle.jpg',
  },
  title: 'What is the item you bought?',
  placeholderTextDigital: 'e.g. Game, app, film download',
  placeholderText: 'e.g. TV, fridge freezer',
}
